import { useSelector } from "react-redux";
import { cn, getContentKeyAccToLang } from "../utils/utils";
import dynamicfunction from "../utils/dynamicfunction";
import Loader from "./Loader";
import ViewItems from "./ViewItems";
import RowView from "./RowView";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import ViewReverse from "./ViewReverse";

const AccountCard = ({ loading = false, data, isPending = false, onPressApplication, currentClientId, isSelectedIcon = false }) => {
    const { isArabic, TextWeight } = dynamicfunction();
    const { authContent } = useSelector((state) => state.content);
    const getContentKey = (key) => {
        return getContentKeyAccToLang(authContent?.web_open_new_account?.data?.attributes, key, isArabic);
    };

    const getIdText = (item) => {
        const type_id = item?.applicantTypeId;
        if (item?.investorTypeId === 1) {
            let text =
                type_id === 12
                    ? getContentKey('ksa_resident')
                    : type_id === 11
                        ? getContentKey('ksa_national')
                        : type_id === 13
                            ? getContentKey('gcc_national')
                            : getContentKey('other_national');
            return text;
        }
        return getContentKey('cr_no');
    };
    return (
        <>
            {loading ? (
                <Loader className='mb-4 mt-10' />
            ) : (
                data?.map((item, index) => {
                    const is_corporate = item?.investorTypeId === 2;
                    const id_number = isPending ? item?.uniqueIdentificationNumber : is_corporate ? item?.commercialRegistrationNumber : item?.nationalIdentificationNumber
                    const name = isPending ? item?.name : item?.fullName
                    const selectedClient = item?.clientId === currentClientId
                    const isDisabled = (selectedClient && isSelectedIcon)
                    return (
                        <ViewItems
                            key={index}
                            className={cn('border border-border justify-center rounded-2xl py-3 px-4', isDisabled ? 'cursor-not-allowed' : 'cursor-pointer')}
                            onClick={() => !isDisabled && onPressApplication(item)}
                        >
                            {(selectedClient && isSelectedIcon) && (
                                <ReactSVG src={icons?.greenTickIcon} />
                            )}
                            <ViewReverse className='justify-between gap-2' isReverse={false}>
                                <ViewItems>
                                    <Text text={getContentKey('application_type')} weight={TextWeight.medium} size={fontSizes.h13} />
                                    <Text text={getContentKey(is_corporate ? 'corporate' : 'individual')} weight={TextWeight.semiBold} size={fontSizes.h14} color='text-primary' className='mt-1.5' />
                                </ViewItems>
                                <ViewItems className={isArabic ? 'items-end' : 'items-end'}>
                                    <Text text={getContentKey('name')} weight={TextWeight.medium} size={fontSizes.h13} />
                                    <Text text={name} weight={TextWeight.semiBold} size={fontSizes.h14} color='text-primary' className='mt-1.5' />
                                </ViewItems>
                            </ViewReverse>
                            <ViewItems className='mt-2'>
                                <Text text={getIdText(item)} weight={TextWeight.medium} size={fontSizes.h13} />
                                <Text
                                    text={id_number}
                                    weight={TextWeight.semiBold}
                                    size={fontSizes.h14}
                                    color='text-primary'
                                    className='mt-1.5'
                                />
                            </ViewItems>
                        </ViewItems>
                    )
                }
                )
            )}
        </>
    )
}
export default AccountCard